(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collecteur', {
            parent: 'entity',
            url: '/collecteur?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.collecteur.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collecteur/collecteurs.html',
                    controller: 'CollecteurController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('collecteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collecteur-detail', {
            parent: 'entity',
            url: '/collecteur/{login}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.collecteur.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collecteur/collecteur-detail.html',
                    controller: 'CollecteurDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('collecteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'User', function($stateParams, User) {
                    return User.get({login : $stateParams.login});
                }]
            }
        
        
        })
        
        
        .state('collecteur.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-dialog.html',
                    controller: 'CollecteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                agence:null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('collecteur');
                });
            }]
        })
        .state('collecteur.edit', {
            parent: 'collecteur',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-dialog.html',
                    controller: 'CollecteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collecteur.delete', {
            parent: 'collecteur',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-delete-dialog.html',
                    controller: 'CollecteurDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
        
    }

})();
